var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 22H36V4C36 1.8125 34.1875 0 32 0H8C5.75 0 4 1.8125 4 4V22H1C0.4375 22 0 22.5 0 23V26C0 29.3125 2.6875 32 6 32H34C37.25 32 40 29.3125 40 26V23C40 22.5 39.5 22 39 22ZM7 4C7 3.5 7.4375 3 8 3H32C32.5 3 33 3.5 33 4V22H7V4ZM37 26C37 27.6875 35.625 29 34 29H6C4.3125 29 3 27.6875 3 26V25H14.25C14.625 25.625 15.25 26 16 26H24C24.6875 26 25.3125 25.625 25.6875 25H37V26ZM17.3125 16.375L18 15.6875C18.4375 15.3125 18.4375 14.625 18 14.25L15.8125 12L18 9.8125C18.4375 9.4375 18.4375 8.75 18 8.375L17.3125 7.6875C16.9375 7.3125 16.3125 7.3125 15.9375 7.6875L12.25 11.3125C11.875 11.6875 11.875 12.375 12.25 12.75L15.9375 16.375C16.3125 16.75 16.9375 16.75 17.3125 16.375ZM21.9375 15.6875L22.625 16.375C23 16.75 23.625 16.75 24 16.375L27.6875 12.75C28.0625 12.375 28.0625 11.6875 27.6875 11.3125L24 7.6875C23.625 7.3125 23 7.3125 22.625 7.6875L21.9375 8.375C21.5 8.75 21.5 9.4375 21.9375 9.8125L24.125 12L21.9375 14.25C21.5 14.625 21.5 15.3125 21.9375 15.6875Z",
    fill: "#F15B28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopCode);
export default __webpack_public_path__ + "static/media/laptop-code.8e37b8b1675a141555ac5bd2d4c05417.svg";
export { ForwardRef as ReactComponent };